import { FunctionalComponent, h } from '@stencil/core';
import Icon from '../Icon/Icon'
export interface AlertProps {
  type: string,
  dismissible?: boolean,
  onAlertClose?: () => any,
}

export const Alert: FunctionalComponent<AlertProps> = (props, children) => {

  const {
    type = '',
    dismissible = false,
    onAlertClose = () => {},
  } = props;

  return(
    <div class={`cai-lact-alert cai-lact-alert-${type} ${type}`}>
        <div class="cai-lact-alert-content">
          <div class="cai-lact-alert-icon">
            {type === 'danger' ?
              Icon.AlertDangerIcon()
            :
            <Icon.GreenCheckmarkIcon size='16'  />
            }
          </div>
          <div class="cai-lact-alert-msg">{children}</div>
        </div>
        {dismissible && (
          <div class="cai-lact-alert-close" onClick={() => onAlertClose()}>
            {Icon.CloseIcon(type)}
          </div>)}
    </div>
  );
}
